<template>
<section v-if="hasPermissions(['Report Read', 'Report Write'])" class="view">
    <Breadcrumb :breadcrumb="breadcrumb" />
    <h1 class="view__title title--1" v-html="title_page" />
    <div class="view__description">
        <p class="view__description__text">
        </p>
    </div>
    <div>
        <FormDynamic :form_format="form_format" :form_data="form_data" :array_options="array_options" :content_align_x="'hh'" />
        <a class="modal__buttons__item w-auto px-3 mt-3" v-html="'Generate Report'" @click="getReport()"/>
    </div>
    <div class="tab-content mt-4" v-show="pdfSource">
        <div class="tab-pane fade active show" id="listation">
            <div class="row mb-0 no-gutters justify-content-md-center">
                <div class="col-lg-10" style="min-height: 60rem">
                    <v-card style="height: 100%">
                        <div>
                            <iframe style="width: 100%; height: 60rem;" :src="pdfSource"></iframe>
                        </div>
                    </v-card>
                </div>
            </div>
        </div>
    </div>
    <WaitingModal />
</section>

<div v-else>
    <UnauthorizedComponent :breadcrumb="breadcrumb" />
</div>
</template>

    
        
        
    
<script>
import axios from 'axios';
import Resources from './resources'
import FormResources from './form_resources'
import Breadcrumb from '@/components/BreadcrumbComponent/Breadcrumb'
import WaitingModal from '@/components/WaitingModal'
import UnauthorizedComponent from '@/components/UnauthorizedComponent'
import { Notyf } from 'notyf'
import 'vuetify/dist/vuetify.min.css'
import 'notyf/notyf.min.css'
import FormDynamic from '@/components/FormDynamic.vue';
const notyf = new Notyf({
    duration: 8000,
});
import _ from 'lodash'

export default {

    name: "NextScheduledProjectsReport",

    components: {
        Breadcrumb,
        WaitingModal,
        UnauthorizedComponent,
        FormDynamic
    },

    data() {
        return {
            notyf,
            axios,
            standard_report_id: 30,
            user: this.get_user(),
            rest_api: `search_standard_reports`,
            title_page: 'Next Scheduled Projects',
            current_url: `/reports`,
            breadcrumb: Resources.breadcrumb,
            form_format: FormResources.form_format_next_scheduled_projects,
            form_data: FormResources.form_data_next_scheduled_projects,
            rooms_report_table_headers: Resources.rooms_report_table_headers,
            rooms_report_table_headers_employee: Resources.rooms_report_table_headers_employee,
            search: '',
            first_request: true,
            searching_levels: false,
            searching_areas: false,
            pdfSource: '',
            array_options: {
                building_id: [],
                level_id: [],
                area_id: [],
                task_id: [],
            }
        };
    },

    methods: {

        backToReports() {
            window.location.href = '/reports'
        },

        async getInitialData(first_request = true) {
            const form_data = {
                module_id: this.standard_report_id,
                first_request: first_request,
                building_id: this.form_data.building_id,
                level_id: this.form_data.level_id,
            }

            const response = await this.post('params_standard_reports', form_data)

            if (response.status) {
                if(first_request) {
                    this.fill_data(response.data)
                }
                else
                {
                    this.array_options = {...this.array_options, level_id: response.data.level_id, area_id: response.data.area_id}
                }

            } else {
                this.error_handling(response)
            }

            this.loader(false)

            return response.data
        },

        async fill_data(data) {
            this.array_options = {
                building_id: data.building_id,
                task_id: data.task_id
            }
        },

        async getReport() {
            const form_data = {
                standard_report_id: this.standard_report_id,
                headers: Resources.next_scheduled_projects_table_headers,
                totals: [],
                format: this.form_data.format,
                params: {...this.form_data}
            }

            this.loader(true)

            const response = await this.post('search_standard_reports', form_data)

            if (response.status) {
                const base64Data = await this.downloadFile(response, true)
                var blobUrl = URL.createObjectURL(base64Data);
                this.pdfSource = blobUrl
            } else {
                this.error_handling(response)
            }

            this.loader()
        },

        async removeOldItems(key) {
            this.form_data[key] = this.form_data[key].filter(item => {
                return this.array_options[key].some(array_option => array_option.id === item);
            });
        },

        async handleBuildingChange() {
            this.searching_levels = true
            const { level_id } = await this.getInitialData(false);
            this.array_options.level_id = level_id;
            if(this.array_options.level_id.length)
            {
                this.notyfMesg('Levels were found')
            }
            else
            {
                this.notyfMesg('No Levels found')
            }
            this.removeOldItems('level_id');
            this.searching_levels = false
        },

        async handleLevelChange() {

            if(this.form_data.level_id.length)
            {
                this.searching_areas = true
                const { area_id } = await this.getInitialData(false);
                this.array_options.area_id = area_id;
                if(this.array_options.area_id.length)
                {
                    this.notyfMesg('Areas were found')
                }
                else
                {
                    this.notyfMesg('No Areas found')
                }

                this.searching_areas = false
            }
            else
            {
                this.form_data.area_id = []
            }
            this.removeOldItems('area_id');
        },
    },
    watch: {
        async 'form_data.building_id' ()
        {
            this.debouncedBuildingChange();  
            
        },

        async 'form_data.level_id' ()
        {
            this.debouncedLevelChange();  
        },
    },

    created() 
    {
        this.debouncedBuildingChange    =   _.debounce(this.handleBuildingChange, 700)
        this.debouncedLevelChange       =   _.debounce(this.handleLevelChange, 700)
    },

    async mounted() {
        if (this.hasPermissions(['Report Read', 'Report Write'])) {
            this.getInitialData()
        }
    },

}
</script>
